// Full-document render of the Oscar account-login view: PageSkeleton (the
// React document shell) wrapping the toppers account-shell layout — the
// customer-service side nav, the "Account Login / Create" content title, and
// the LoginStandalone form island. The content title copy + phone arrive as
// props (server-side gettext / customer-service settings); the login page has
// no brand heading or customer-service info block (page_copy / cs_info stay
// unused).
import React from "react";

import { templates } from "@reactivated";

import { AccountShell } from "../components/AccountShell";
import { PageSkeleton } from "../components/PageSkeleton";
import { Template as LoginStandalone } from "./LoginStandaloneTemplate";

export const Template = (
    props: templates.LoginDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountShell
            hasNav={props.has_nav}
            sideNav={props.side_nav}
            title={props.content_title}
            phoneDisplay={props.phone_display}
            phoneHref={props.phone_href}
        >
            <div className="login-standalone">
                <LoginStandalone {...props.login_standalone} />
            </div>
        </AccountShell>
    </PageSkeleton>
);
